import { ICmsPage } from './../../resource/page/icms-page';
import { NICmsContentField } from './icms-content-field.interfaces';

export namespace NICmsContentPageType {
    export const defaultPageTypeId = 'default';

    export interface IMeta {
        /**
         * Type if (saved in data, used as page.data.pageType)
         */
        id: string;
        /**
         * Type title (presented to user in iCMS)
         */
        title: string;

        /**
         * Optional fields used with the type
         */
        fields?: IField[];
        /**
         * Parent page filter
         */
        parentFilter?: (page: ICmsPage) => boolean;
    }

    export interface IField extends NICmsContentField.IField {
        /**
         * If field needs to appear in page init form
         */
        initial?: boolean;
        /**
         * Tab id in page edit form
         * defaults to general
         */
        tab?: string;
    }
}
